var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 138,
    viewBox: "0 0 190 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 0H56.7608C26.8465 0 1.16545 23.4587 0.0366159 53.4179C-1.09222 85.073 24.0244 110.793 55.3497 110.793H90.9081C93.1658 110.793 94.8591 112.489 94.8591 114.75V134.817C94.8591 137.643 98.2456 139.056 100.221 137.078L125.338 111.923C126.184 111.075 127.031 110.793 128.16 110.793H133.24C163.154 110.793 188.835 87.3341 189.964 57.3748C191.093 26.0024 165.694 0 134.651 0Z",
    fill: "#47B972"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.76 71.4235L115.016 57.9297L97.6264 71.4141C96.174 72.531 95.3245 74.2599 95.3279 76.0914V83.541H135.109V76.1349C135.098 74.2847 134.231 72.5446 132.76 71.4235Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4142 16H139.367C139.551 16 139.7 16.1486 139.7 16.3321V25.0668C139.7 25.2503 139.551 25.3989 139.367 25.3989H90.4142C90.2306 25.3989 90.082 25.2503 90.082 25.0668V16.3321C90.082 16.1486 90.2306 16 90.4142 16V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4142 86.6016H139.367C139.551 86.6016 139.7 86.7501 139.7 86.9337V95.6683C139.7 95.8519 139.551 96.0005 139.367 96.0005H90.4142C90.2306 96.0005 90.082 95.8519 90.082 95.6683V86.9337C90.082 86.7501 90.2306 86.6016 90.4142 86.6016Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1094 35.3015C95.1085 37.1023 95.9299 38.8048 97.3404 39.9241L114.996 54.0404L132.656 39.9241C134.068 38.8048 134.891 37.1023 134.891 35.3015V28.459H95.1094V35.3015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwait);
export default __webpack_public_path__ + "static/media/cwait.cb677becad7cbf9da3b4d08bad4f5ea5.svg";
export { ForwardRef as ReactComponent };